module.exports = __webpack_public_path__ + "static/media/ForwardArrow.75ac75c1.svg";